import axios from 'axios';
import { rawP1Service } from '../../services/P1Service';
import { P1Response } from '../../types/p1Service';

export interface OrgUnitCategory {
  code: string;
  name: string;
}

export interface OrgUnit {
  code: string;
  name: string;
}

export async function getOrgUnitCategories() {
  return await rawP1Service.get<P1Response<OrgUnitCategory[]>>('/api/OrgUnit/Category');
}

export async function getOrgUnitsByCategory(category: string) {
  return await rawP1Service.get<P1Response<OrgUnit[]>>(`/api/OrgUnit/Category/${category}`);
  
}
